import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const pains = ['You spend too much time searching for drills or inventing exercises at the last minute', "You don't have a clear progression by skill level and end up repeating the same things", "You arrive at practice with sessions that aren't fluid and explanations that are too long", 'You have no serious library of drills and variations to pull from without starting from scratch', 'When the week gets complicated, your planning falls apart and you improvise too much', 'You want to look more prepared and professional — but without a ready system you waste hours'];
export const PainPoints = () => {
  return <section className="py-12 md:py-24 bg-slate-50 text-navy-900" data-id="element-167">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-169">
          <h2 className="text-xl md:text-3xl font-bold mb-4" data-id="element-170">
            If every week you lose hours organizing practice, this will sound
            familiar:
          </h2>
          <div className="w-16 md:w-24 h-1 bg-vbred mx-auto" data-id="element-171" />
        </motion.div>

        <div className="space-y-3 md:space-y-4" data-id="element-172">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -2,
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.05)'
        }} className="flex items-start gap-3 md:gap-4 bg-white p-4 md:p-6 shadow-sm border border-slate-200 rounded-xl transition-shadow duration-300" data-id="element-173">
              <div className="flex-shrink-0 mt-0.5 md:mt-1" data-id="element-174">
                <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-red-100 flex items-center justify-center" data-id="element-175">
                  <X className="w-4 h-4 md:w-5 md:h-5 text-vbred" data-id="element-176" />
                </div>
              </div>
              <p className="text-base md:text-lg text-slate-700 font-medium pt-0.5 md:pt-1" data-id="element-177">
                {pain}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};